module.exports = __webpack_public_path__ + "img/form-img3.e4ef97a6.png";